"use strict";
/**
 * @file Created on Tue May 21 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DummyWindowAppendDTO_1 = require("../model/DummyWindowAppendDTO");

var DummyWindowAppendDTOConverter_1 = require("./DummyWindowAppendDTOConverter");
/**
 * @author BPo
 */


var DummyWindowAppendDTOConverterImpl =
/*#__PURE__*/
function (_DummyWindowAppendDTO) {
  _inherits(DummyWindowAppendDTOConverterImpl, _DummyWindowAppendDTO);

  function DummyWindowAppendDTOConverterImpl() {
    _classCallCheck(this, DummyWindowAppendDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowAppendDTOConverterImpl).apply(this, arguments));
  }

  _createClass(DummyWindowAppendDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new DummyWindowAppendDTO_1.DummyWindowAppendDTO(DummyWindowAppendDTO_1.DummyWindowAppendDTO.schema.dummyWindowId.valueOf(conversions.toClassReferenceId(source.dummyWindowId)), DummyWindowAppendDTO_1.DummyWindowAppendDTO.schema.volume.valueOf(conversions.toBigNumber(source.volume)), DummyWindowAppendDTO_1.DummyWindowAppendDTO.schema.promoPrice.valueOf(conversions.toBigNumber(source.promoPrice)), DummyWindowAppendDTO_1.DummyWindowAppendDTO.schema.promoPurchasePrice.valueOf(conversions.toBigNumber(source.promoPurchasePrice)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        dummyWindowId: conversions.toDocumentReferenceId(source.dummyWindowId),
        volume: conversions.fromBigNumber(source.volume),
        promoPrice: conversions.fromBigNumber(source.promoPrice),
        promoPurchasePrice: conversions.fromBigNumber(source.promoPurchasePrice)
      });
      return result;
    }
  }]);

  return DummyWindowAppendDTOConverterImpl;
}(DummyWindowAppendDTOConverter_1.DummyWindowAppendDTOConverter);

exports.DummyWindowAppendDTOConverterImpl = DummyWindowAppendDTOConverterImpl;